import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export type FilterMode = "all" | "mine" | "user";

/**
 * UI 설정 전역 상태 (localStorage persist)
 */
interface SettingsState {
  // 건물 필터 모드
  filterMode: FilterMode;
  filterUserId: string | null;
  setFilterMode: (mode: FilterMode, userId?: string) => void;

  // 내 건물만 보기 (레거시 호환용, filterMode와 동기화)
  showOnlyMyBuildings: boolean;
  setShowOnlyMyBuildings: (value: boolean) => void;

  // BGM 재생 상태
  isBgmPlaying: boolean;
  setIsBgmPlaying: (value: boolean) => void;

  // 가장자리 스크롤 기능
  enableEdgeScroll: boolean;
  setEnableEdgeScroll: (value: boolean) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      // 건물 필터 모드 (기본값: all)
      filterMode: "all" as FilterMode,
      filterUserId: null,
      setFilterMode: (mode, userId) =>
        set({
          filterMode: mode,
          filterUserId: mode === "user" ? userId || null : null,
          // 레거시 상태 동기화
          showOnlyMyBuildings: mode === "mine",
        }),

      // 내 건물만 보기 (레거시 호환용)
      showOnlyMyBuildings: false,
      setShowOnlyMyBuildings: (value) =>
        set({
          showOnlyMyBuildings: value,
          filterMode: value ? "mine" : "all",
          filterUserId: null,
        }),

      // BGM 재생 상태 (기본값: false - 인트로 후 재생)
      isBgmPlaying: false,
      setIsBgmPlaying: (value) => set({ isBgmPlaying: value }),

      // 가장자리 스크롤 기능 (기본값: false)
      enableEdgeScroll: false,
      setEnableEdgeScroll: (value) => set({ enableEdgeScroll: value }),
    }),
    {
      name: "isometric-city-settings",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
